// Auto-generated from server/src/Jobs.Domain/Constants/ServicePlanProductConstants.cs
// Do not modify manually - run 'npm run generate-constants' to regenerate

export const ServicePlanProductConstants = {
  OneYearAnnual: 'fd8970d6-216b-43d7-848e-29fedbffdd68',
  ThreeYearAnnual: 'e5bfb3d5-0034-4c38-bf2c-4b87e5803fc9',
  FiveYearAnnualWithClenit: '26bb0113-1337-4df8-aba5-6388100447f9',
  FiveYearAnnual: '115a0406-9091-42f0-8c72-8b4f53a9c16e',
  OneYearAnnualWithClenit: '5744c965-73a9-44de-b1ef-972ad2193323',
  ThreeYearAnnualWithClenit: 'cecc8a41-6315-4173-944f-c9bd42140f9e'
} as const;
